module.exports = __webpack_public_path__ + "img/IMG_1039_L_Black.b865e8c5.jpg";